module.exports = __webpack_public_path__ + "img/autozone.0b2dbcfd.png";